/**
 * Created by razkoller on 09/05/2017.
 */

if (window.jQuery) {
    window.jQuery(function ($) {

        $('.sectionsBtn').click(function () {
            if ($('#sectionsMenu').is(':visible')) {
                $('#sectionsMenu').slideUp();
            } else {
                $('#sectionsMenu').slideDown();
            }
        });

        $('.sectionsBtnSticky').click(function () {
            $('#sectionsMenuSticky').toggle();
            trackCTA('clicked on sections');
        });

        $('.menuBtn').click(function (e) {
            e.preventDefault();
            var target = $(this).attr('data-target');
            $('#' + target).toggle();
        });

        $('i.goBack').click(function (e) {
            e.preventDefault();
            $('.side-nav').css('transform', 'translateX(0px)');
            var target = $(this).attr('data-target');
            $('#' + target).toggle();
        });

        $('.brand-logo.onlyOnMobileMenu').click(function(){
          if ($('#sectionMobileMenu').is(':visible') === true) {
            $('#sectionMobileMenu').toggle();
            $('.brand-logo.onlyOnMobileMenu').click();
          }
          if ($('#socialMobileMenu').is(':visible') === true) {
            $('#socialMobileMenu').toggle();
            $('.brand-logo.onlyOnMobileMenu').click();
          }
        });

    });
}